import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanel from "./Admin Panel/AdminPanel";
import AdminRoute from "./Admin Panel/adminRoute";
import DataEntryForm from "./Admin Panel/dataEntryForm";
import ClassResources from "./User Panel/classResources";
import ChapterResources from "./User Panel/ChapterResources";
import Home from "./User Panel/Home";
import Login from "./Admin Panel/Login"; // ✅ import login screen
import Navbar from "./components/Navbar";
import ClassGuide from "./components/ClassGuide";
import AboutUs from "./components/AboutUs";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes with Navbar */}
        <Route path="/" element={
          <>
            <Navbar />
            <Home />
          </>
        } />
        <Route path="/class/:grade" element={
          <>
            <Navbar />
            <ClassResources />
          </>
        } />
        <Route path="/class/:grade/chapter/:slug" element={
          <>
            <Navbar />
            <ChapterResources />
          </>
        } />

        <Route path="/guide/:grade" element={
          <>
            <Navbar />
            <ClassGuide />
          </>
        } />

        <Route path="/about" element={
          <>
            <Navbar />
            <AboutUs />
          </>
        } />

        <Route path="/blog" element={
          <>
            <Navbar />
            <Blog />
          </>
        } />

        <Route path="/blog/:slug" element={
          <>
            <Navbar />
            <BlogPost />
          </>
        } />

        {/* Routes without Navbar */}
        <Route path="/login" element={<Login />} />

        {/* 🔐 Admin-only routes */}
        <Route path="/admin" element={
          <AdminRoute>
            <AdminPanel />
          </AdminRoute>
        } />

        <Route path="/admin/add-resource" element={
          <AdminRoute>
            <DataEntryForm />
          </AdminRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
